const _ = require('underscore');

var MODULES_MAP = {};

module.exports = {
    getInitialState: function () {
        return {
            fieldModules: {}
        };
    },

    addModules: function (obj) {
        _.extend(
            MODULES_MAP,
            obj
        );
    },

    addLoader: function (func) {
    },

    loadModules: function (fieldsDict) {
        var _this = this;

        var modules = _.uniq(
            _.map(
                _.keys(fieldsDict),

                function (key) {
                    var obj = fieldsDict[key];

                    if (obj == null) { return; }

                    return obj.module;
                }
            )
        );

        this.fieldDefs = _.map(
            modules,

            (modulePath) => {
                var def = $.Deferred();

                var loader = MODULES_MAP[modulePath];

                if (loader == null) {
                    def.reject();
                    return def;
                }

                loader(
                    (module) => {
                        def.resolve(module);

                        this.setState(
                            {
                                fieldModules: _.extend(
                                    this.state.fieldModules,
                                    {
                                        [modulePath]: module
                                    }
                                )
                            }
                        );
                    }
                );

                return def;
            }
        );
    },

    cancelModulesLoad: function () {
        _.each(
            this.fieldDefs,

            function (def) {
                def.reject();
            }
        );

        delete this.fieldDefs;
    },

    componentDidMount: function () {
        this.loadModules(this.props.fieldsDict);
    },

    componentWillUnmount: function () {
        this.cancelModulesLoad();
    },

    componentWillReceiveProps: function (nextProps) {
        if (this.props.fieldsDict !== nextProps.fieldsDict) {
            this.cancelModulesLoad();

            this.loadModules(
                nextProps.fieldsDict
            );
        }
    }
};